import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-back\"><defs><style type=\"text/css\"></style></defs><path d=\"M288.96 96v118.784h287.232c194.304 0 351.808 159.68 351.808 356.608S770.496 928 576.192 928H96v-90.048h480.192c145.28 0 262.976-119.36 262.976-266.56s-117.76-266.56-262.976-266.56H94.656v-46.144L259.456 96h29.504z\" fill=\"#ffffff\" p-id=\"2012\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol